import { ClerkProvider } from '@clerk/clerk-react';
import { frFR } from '@clerk/localizations';
import { dark } from '@clerk/themes';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { BrowserRouter } from 'react-router-dom';

import { AntdThemeProvider } from '@/app/providers/AntdThemeProvider';
import { ThemeProvider } from '@/app/providers/ThemeProvider';
import { AppRouter } from '@/app/router';

// Create a client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      gcTime: 1000 * 60 * 30, // 30 minutes
    },
  },
});

const publishableKey = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY;

if (!publishableKey) {
  throw new Error('Missing Clerk Publishable Key');
}

function AppContent() {
  return (
    <>
      <AppRouter />
      <ReactQueryDevtools initialIsOpen={false} />
    </>
  );
}

export function App() {
  return (
    <ClerkProvider
      publishableKey={publishableKey}
      localization={frFR}
      appearance={{
        baseTheme: dark,
      }}
      signInUrl="/sign-in"
      signUpUrl="/sign-up"
      afterSignOutUrl={import.meta.env.VITE_AFTER_SIGNOUT_URL || '/'}
    >
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <ThemeProvider>
            <AntdThemeProvider>
              <AppContent />
            </AntdThemeProvider>
          </ThemeProvider>
        </BrowserRouter>
      </QueryClientProvider>
    </ClerkProvider>
  );
}
